import React from 'react';
import Form from "./Form";
import Joi from 'joi-browser';
import { sendMessage } from '../services/ferretService.js';

export class Message extends Form {


  state = {
    data: {
      name: "",
      email: "",
      message: ""
    },
    errors: {

    },
    sent: false,
    responseMessage:null
  };

  doSubmit = async () => {
    try {
      const response = await sendMessage(this.state.data);

      this.setState({ sent: response.isOk, responseMessage:response.message });

    } catch (ex) {
      if (ex.response && ex.response.status === 400) {
        const errors = { ...this.state.errors };
        errors.username = ex.response.data;
        this.setState({ errors });
      }
    }

  }

  schema = {
    email: Joi.string().email().required().label('Email'),
    name: Joi.string().min(5).required().label('Name'),
    message: Joi.string().required().label('Message')
  }

  render() {
    return (<div className="p-3">
              <p>Use this form to send us a message, we love to have feedback good or bad. If you would like to see a store added or have a feature request, please get in touch.</p>
              <form onSubmit={this.handleSubmit}>
                {this.renderInput("name", "Name", "text")}
                {this.renderInput("email", "Email", "email")}
                {this.renderTextArea("message", "Message")}
                {!this.state.sent && this.renderButton("Send")}
      </form>

      {this.state.responseMessage && <div className="">
        <span>{this.state.responseMessage}</span>
      </div>}
      
    </div>);
  }
}